import React, {
  ReactNode,
  createContext,
  useState,
  useContext,
  useEffect,
} from "react";
import { envVars, globalEnvValues } from "../env/envValues";

type EnvironmentContextType = {
  env: envVars;
  setEnv: React.Dispatch<React.SetStateAction<envVars>>;
};

const EnvironmentContext = createContext<EnvironmentContextType | undefined>(
  undefined
);

export const EnvironmentProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [env, setEnv] = useState<envVars>(() => {
    const storedEnv = localStorage.getItem("env");
    return storedEnv ? JSON.parse(storedEnv) : globalEnvValues;
    //return globalEnvValues;
  });

  useEffect(() => {
    localStorage.setItem("env", JSON.stringify(env));
  }, [env]);

  return (
    <EnvironmentContext.Provider value={{ env, setEnv }}>
      {children}
    </EnvironmentContext.Provider>
  );
};

export const useEnv = () => {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error("useEnv must be used within an EnvironmentProvider");
  }
  return context;
};
